<template>
    <div class="body">
		<div class="title">
			<p class="span1">2025</p>
			<p class="span2">富学宝典</p>
			<p class="span3">十一月学习报告</p>
			<p class="span4">坚持学习的人永葆青春</p>
		</div>
		
		<div class="form" v-show="playtimeShow">
			<input class="input" placeholder="请输入工号" v-model="thisJobNo" type="text">
			<span class="input-border"></span>
		</div>

		<button v-show="playtimeShow" :style="'margin-top:'+ windowWidth*0.21 +'px;'" @click="sumbitJobNo"> let's go<span></span></button>
		<div class="footer-content" v-show="footerVisible">
			<p style="margin: 0;">版权所有：富泰华工业（深圳）有限公司 </p >
			<p style="margin: 0;">备案号：<a href="https://beian.miit.gov.cn">粤ICP备13021698号</a ></p >
		</div>
    </div>
</template>
  
<script>
import jieliufa from '@/utils/jieliufa'
export default {
	data() {
		return {
			thisJobNo: '',
			buttonShow: true,
			windowWidth: window.innerHeight,
			playtimeShow: true,
      footerVisible: true,
      originalHeight: 0
		}
	},
  mounted() {
      this.originalHeight = window.innerHeight;

      window.addEventListener('resize', () => {
          if (window.innerHeight < this.originalHeight - 100) {
              // 键盘弹出
              this.footerVisible = false;
          } else {
              // 键盘收起
              this.footerVisible = true;
          }
      });
  },

	methods: {
		sumbit: jieliufa.throttle(function() {
			/*节流：
			*在规定的时间间隔范围内不会重发触发回调，只有大于时间间隔才会触发回调
			*也就是说，把频发触发变成少量触发
			*/
			this.sumbitJobNo()
		},1000),
		sumbitJobNo() {
			if (!this.thisJobNo) {
				this.$message({
					message: "工号不能为空",
					type: "warning",
					center: true
				})
				return
			}
			this.$emit('inputJobNo',this.thisJobNo)
		},
	}
}
</script>
  
<style scoped>
.body {
    background:url("../../assets/25November/bg.jpg")  no-repeat;
    background-size: 100% 100%,cover;
    width: 100%;
    height: 100vh;
}

.title {
    padding-top:17vh;
    /* display:flex; */
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}

.span1 {
    width:100vw;
    margin:0;
    text-align: center;
    font-size: 51px;
    font-weight: 800;
    color: #35302f;
    /* text-shadow: #fff 0px 0px 2px,   #fff 0px 0px 2px,   #fff 0px 0px 2px, #fff 0px 0px 2px,   #fff 0px 0px 2px,   #fff 0px 0px 2px; */
    font-family:'Gentium Basic', serif;
}

.span2 {
    width:100vw;
    margin:0;
    text-align: center;
    font-weight: bolder; 
    font-size: 32px;
    color: #d03327;
    text-shadow: #fff 0px 0px 2px,   #fff 0px 0px 2px,   #fff 0px 0px 2px, #fff 0px 0px 2px,   #fff 0px 0px 2px,   #fff 0px 0px 2px;
    font-family: 'Eczar', cursive,sans-serif;
}

.span3 {
    max-width: 200px;
    margin:0 auto;
    margin-top: 10px;
    background:rgb(64, 116, 179);
    padding: 4px 17px;
    border-radius: 11px;
    text-align: center;
    background: linear-gradient(290deg,#d03327,#df704b);
    font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman',cursive, serif; 
    color: #fcfadf;
}

.span4 {
    width:100vw;
    text-align: center;
    font-size: 20px;
    color: #d03327;
    font-family: 'Eczar', cursive,sans-serif;
}

.form {
    --width-of-input: 270px;
    --border-height: 1px;
    --border-before-color: #fff;
    position: relative;
    width: var(--width-of-input);
    margin: 0 auto;
    top: 77px;
}

.input {
    color: #000;
    font-size: 1.1rem;
    background-color: transparent;
    width: 100%;
    box-sizing: border-box;
    padding-inline: 0.5em;
    padding-block: 0.7em;
    border: none;
    border-bottom: var(--border-height) solid var(--border-before-color);
    font-family: monospace;
}

.input-border {
    position: absolute;
    background: var(--border-after-color);
    width: 0%;
    height: 2px;
    bottom: 0;
    left: 0;
    transition: 0.3s;
}

input:focus {
    outline: none;
}  
  
button {
    width: 7em;
    position: absolute;
    height: 2.5em;
    border: 3px ridge #7dd7e2;
    outline: none;
    background-color: transparent;
    color: #d03327;
    transition: 1s;
    border-radius: 0.3em;
    font-size: 16px;
    font-weight: bold;
    left: 50%;
    transform: translateX(-50%);
    animation: light 3s infinite;
}
  
@keyframes light {
    0%{
      	box-shadow: inset 0px 0px 7px #bde3f1;
    }
    50%{
      	/* letter-spacing: 0.25em; */
      	box-shadow: inset 0px 0px 47px #9dc9d7;
    }
    100%{
		/* letter-spacing: 0.25em; */
		box-shadow: inset 0px 0px 7px #9cc3db;
    }
}
  
button::after {
    content: "";
    position: absolute;
    top: -10px;
    left: 3%;
    width: 95%;
    height: 40%;
    background-color: #21212100;
    transition: 0.5s;
    transform-origin: center;
}
  
button::before {
    content: "";
    transform-origin: center;
    position: absolute;
    top: 80%;
    left: 3%;
    width: 95%;
    height: 40%;
    background-color: #21212100;
    transition: 0.5s;
} 
.footer-content {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 10px 0;
    text-align: center;
    font-size: 14px;
}
@media screen and (min-width: 1024px) {
  .body {
    background:url("../../assets/25November/pcbg.jpg")  no-repeat;
    background-size: cover;
    padding: 10px;
  }


  .form {
    --width-of-input: 80%;
    top: 30px;
  }

  .input {
    text-align: center;
    font-size: 24px;
  }
  .span1 {
    font-size: 64px !important;
  }
  .span2 {
    font-size: 64px !important;
  }
  .span3 {
    max-width: 700px;
    margin:0 auto;
    font-size: 54px !important;
    text-align: center;
  }
  .span4 {
    font-size: 38px !important;
  }

}
</style>